/**
 * Lightspeed User List Report
 *
 * Lightspeed POS user accounts across all franchise partners
 * with per-FP summary in Excel export.
 */
import BaseReportPage, { ColumnDef, ColumnGroup } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code' },
  { key: 'franchise_name', label: 'Franchise', type: 'text' },
  { key: 'fp_status', label: 'FP Status' },
  { key: 'market', label: 'Market' },
  { key: 'ls_id', label: 'Lightspeed ID', minWidth: 20 },
  { key: 'username', label: 'Username', align: 'left' },
  { key: 'display_name', label: 'Display Name', minWidth: 150, align: 'left' },
  { key: 'email', label: 'Email', minWidth: 200, align: 'left' },
  { key: 'account_type', label: 'Account Type', filterable: true },
  { key: 'roles', label: 'Roles', minWidth: 150, align: 'left' },
  { key: 'enabled', label: 'Enabled', type: 'boolean_indicator' },
  { key: 'is_primary_user', label: 'Primary User', type: 'boolean_indicator' },
  { key: 'enabled_mfa_otp', label: 'MFA Enabled', type: 'boolean_indicator' },
  { key: 'email_verified_at', label: 'Email Verified', type: 'date' },
  { key: 'seen_at', label: 'Last Seen', type: 'datetime' },
  { key: 'deleted_at', label: 'Deleted', type: 'datetime' },
]

const columnGroups: ColumnGroup[] = [
  { label: null, columnKeys: ['fp_code', 'franchise_name', 'fp_status', 'market'] },
  { label: 'Account', columnKeys: ['ls_id', 'username', 'display_name', 'email', 'account_type', 'roles'] },
  { label: 'Status', columnKeys: ['enabled', 'is_primary_user', 'enabled_mfa_otp', 'email_verified_at', 'seen_at', 'deleted_at'] },
]

export default function LightspeedUserListReport() {
  return (
    <BaseReportPage
      reportType="lightspeed_user_list"
      title="Lightspeed User List"
      description="Lightspeed POS user accounts across all franchise partners."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
      }}
      columns={columns}
      columnGroups={columnGroups}
      defaultSortColumn="franchise_name"
    />
  )
}
